// @flow
import * as React from 'react';
import {Switch, Redirect, Route, useRouteMatch} from 'react-router-dom';
import Survey from './Survey';
import SurveyResult from './SurveyResult';
import ExteriorColor from './ExteriorColor';
import DrivingPass from './DrivingPass';

export default function SurveyRouter(): React.Element<any> {
  const {path, url} = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <Survey nextPath={`${url}/:cv`} />
      </Route>
      <Route path={`${url}/:cv/exterior-color`}>
        <ExteriorColor nextPath={`${url}/:cv/driving-pass`} />
      </Route>
      <Route path={`${url}/:cv/driving-pass`}>
        <DrivingPass nextPathA="/driving-zone/course-a" nextPathB="/driving-zone/course-b"/>
      </Route>
      <Route path={`${url}/:cv`}>
        <SurveyResult prevPath={`${url}`} nextPath={`${url}/:cv/exterior-color`} />
      </Route>
      <Redirect to={path} />
    </Switch>
  );
}
